<template>
  <slot
    :dialog-binds="dialogBinds"
    :backdrop-binds="backdropBinds"
  />
</template>

<script setup>
import { ref, watch, toRef, reactive, onUnmounted } from 'vue'
import { uniqueId } from 'gleam-shared/helpers/nodash'
import { trapFocus, releaseFocus } from 'gleam-shared/browser/focustrap'
import HELP_CENTER_BREAKPOINTS from 'help-center/constants/breakpoints'

const emit = defineEmits(['close'])
const props = defineProps({
  open: {
    type: Boolean,
    required: true
  },
  dialog: Boolean
})

const marker = uniqueId('HelpCenterDialog')

const openRef = toRef(props, 'open')
const dialogRef = ref(null)

const dialogBinds = reactive({ ref: onDialogRef, open: openRef })
const backdropBinds = { onClick }

onUnmounted(revertTrap)
watch([openRef, dialogRef], manageTrap)
watch(openRef, manageKeydownListener)

function onDialogRef(value) {
  dialogRef.value = value
}

function onClick() {
  const isDesktop = matchMedia(`(min-width: ${HELP_CENTER_BREAKPOINTS.md})`)
  if (isDesktop.matches) {
    emitClose()
  }
}

function onKeydown(event) {
  if (event.key === 'Escape') {
    emitClose()
  }
}

function emitClose() {
  emit('close')
}

function revertTrap() {
  releaseFocus(marker)
}

function manageTrap([open, dialog]) {
  if (open && dialog) {
    trapFocus(marker, [dialog])
  } else {
    releaseFocus(marker)
  }
}

function manageKeydownListener(open) {
  if (open) {
    window.addEventListener('keydown', onKeydown, { passive: true })
  } else {
    window.removeEventListener('keydown', onKeydown)
  }
}
</script>
